import { cellRefText, sheetRefPrefix, type Token, tokenize } from "@package/scratchpad-utils";

export type SheetNameResolver = (name: string) => string | undefined;

function canonicalToken(t: Token, resolveSheet?: SheetNameResolver): string | null {
  switch (t.kind) {
    case "ref": {
      const { start, end } = t.addr;
      const sheet = start.sheet ? sheetRefPrefix(resolveSheet?.(start.sheet) ?? start.sheet) : "";
      return `${sheet}${cellRefText(start)}${end ? `:${cellRefText(end)}` : ""}`;
    }
    case "func":
      return t.name.toUpperCase();
    case "bool":
      return t.value ? "TRUE" : "FALSE";
    default:
      return null;
  }
}

export function normalizeFormula(src: string, resolveSheet?: SheetNameResolver): string {
  if (!src.startsWith("=")) return src;
  let tokens: Token[];
  try {
    tokens = tokenize(src.slice(1));
  } catch {
    return src;
  }
  let out = src;
  for (let i = tokens.length - 1; i >= 0; i--) {
    const t = tokens[i]!;
    const text = canonicalToken(t, resolveSheet);
    if (text === null) continue;
    out = out.slice(0, t.span.start + 1) + text + out.slice(t.span.end + 1);
  }
  return out;
}
